import { AxiosRequestConfig } from "axios";
import { AXIOS_INSTANCE, BASE_URL } from "../App";

export async function getSeasonality(salesOrg: string) {
  const config: AxiosRequestConfig = {
    method: "GET",
    params: {
      clientId: "100",
      salesOrg,
    },
    url: `${BASE_URL}/api/seasonality/seasonalityAdmin`,
  };

  return await AXIOS_INSTANCE(config)
    .then((v) => v.data)
    .catch((err) => console.error(err));
}

export async function saveImportedSeasonality(salesOrg: string, data: any) {
  const config: AxiosRequestConfig = {
    method: "POST",
    params: {
      clientId: "100",
      salesOrg,
    },
    data: data,
    url: `${BASE_URL}/api/seasonality/seasonalityImport`,
  };

  return await AXIOS_INSTANCE(config)
    .then((v) => v.data)
    .catch((err) => console.error(err));
}

export async function deleteSeasonality(salesOrg: string, columnName: string, columnValue: number) {
  //
  const config: AxiosRequestConfig = {
    method: "DELETE",
    params: {
      clientId: "100",
      salesOrg,
    },
    data: {
      typeOf: columnName,
      id: columnValue,
    },
    url: `${BASE_URL}/api/seasonality/seasonalityCustomer`,
  };

  return await AXIOS_INSTANCE(config)
    .then((v) => v.data)
    .catch((err) => console.error(err));
}

export async function editSeasonality(salesOrg: string, data: any) {
  //
  const config: AxiosRequestConfig = {
    method: "PUT",
    params: {
      clientId: "100",
      salesOrg,
    },
    data: data,
    url: `${BASE_URL}/api/seasonality/seasonalityUpdate`,
  };

  return await AXIOS_INSTANCE(config)
    .then((v) => v.data)
    .catch((err) => console.error(err));
}
